import * as i0 from "@angular/core";
export class GlobalsService {
    constructor() {
        // Local
        //  dataUrl = 'http://localhost/salud-cannabis/'
        // Development
        // dataUrl = 'https://salud-mc-api-prop-fbf3c7c2d9haevfe.westus2-01.azurewebsites.net/';
        // sa = 'https://xworkssa.blob.core.windows.net/uploadedfiles';
        // Production
        this.dataUrl = 'https://as-salud-mc-api-axdqdrdadwcjajff.eastus2-01.azurewebsites.net/';
        this.sa = 'https://saludcannabislicprod.blob.core.windows.net/uploadedfiles';
        this.showEventCodePayment = false;
        this.loginData = {
            access_token: '',
        };
    }
}
GlobalsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GlobalsService_Factory() { return new GlobalsService(); }, token: GlobalsService, providedIn: "root" });
